(function () {
    'use strict';

    angular
        .module('app')
        .factory('jquery', jquery);

    jquery.$inject = ['$window'];

    function jquery($window) {
        return $window.jQuery || angular.element;
    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/factories/_jquery.js
// module id = 9
// module chunks = 0